export enum PrettyMetricActions {
  answered = 'Answered',
  call_ended = 'Call ended',
  called = 'Called',
  cut_off = 'Cut off',
  transferred = 'Transferred',
  transfer_error = 'Transfer Error',
}
